module.exports = __webpack_public_path__ + "static/media/icon-summary-active.1de33f34.svg";